// extracted by mini-css-extract-plugin
export default {"button":"Login_button__NDI+T","screenCenter":"Login_screenCenter__s3wKj"};